module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_office_color_orange-ad6695649ca141d6766ca0565fea0400.svg";